// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__m1Tzp","submit":"styles_submit__Pzi5m"};